<template lang="pug">
  el-container.container
    #tool-bar(v-if="show")
      el-form(inline label-suffix=":")
        city-select(v-model="city" @change="changeCity" @show="changeShow")
        el-form-item
          el-button(type="success" icon="el-icon-search" @click="getData") 刷新
    a-map.map(ref="amap")
    .monitor-total(v-if="this.totalBikes") 共{{this.totalBikes}}辆
</template>

<script>
import citySelect from '@/components/citySelect';
import { getMonitorMapData } from '@/api/report';
import AMap from '@/components/AMap';
import Bike from './bike';

const FILTER_ENUM = {
  str: {},
  num: {},
};
const FILTER_DESC = {};
const FILTER_LVL = {};
const FILTERS = [
  ['isRiding', 101, '骑行中', 1],
  ['isReserved', 102, '预约中', 1],
  ['isAvailable', 100, '闲置中', 1],

  // 以下是为了兼容弹框
  // [name, value, 描述, 级别]
  ['isOutArea', 1, '超出运营区', 2],
  // ['isInErrorArea', 2, '疑似进入小区'],
  ['isOvertime', 3, '超时未锁车', 2],
  ['isLost', 4, '失联车辆(最后位置)', 3],
  // ['isAutoReport', 5, '单车主动报障'],
  ['isUserAlert', 6, '用户报障', 3],
  ['isPowerAlert', 7, '电量低', 3],
  ['isSIMRSSIAlert', 8, '信号弱', 3],
  ['isLessRideAlert', 9, '长期未骑行', 2],
  ['isErrorOpenAlert', 10, '连续开锁失败', 3],
  ['isExceptionMove', 11, '异常挪动', 3],

  ['isForbidden', 103, '暂停中', 1],
  ['isCarrying', 104, '维修中', 1],

  ['isInLine', 105, '生产中', 1],
  ['isQualified', 106, '供应合格', 1],

  ['normal', 1000, '通用'],
];
FILTERS.forEach((item) => {
  [
    FILTER_ENUM.str[item[1]],
    FILTER_ENUM.num[item[0]],
    FILTER_DESC[item[0]],
    FILTER_LVL[item[1]]
  ] = item;
});
const BikeType = {
  // 普通车
  NORMAL: 0,
  // 红包车
  RED_PACKET: 200,
};

export default {
  name: 'Heatmap',
  components: {
    citySelect,
    AMap
  },
  data() {
    return {
      city: '',
      map: null,
      totalBikes: 0,
      show: true
    };
  },
  computed: {},
  async mounted() {
    this.map = await this.$refs.amap.getMap();
    window.AMap.event.addListener(this.map, 'zoomend', () => {
      this.getData();
    });
    window.AMap.event.addListener(this.map, 'moveend', () => {
      this.getData();
    });
  },
  methods: {
    async getData() {
      if (!this.city) {
        this.map.remove(this.map.getAllOverlays('marker'));
        return this.$message.error('请选择城市!');
      }
      const bounds = this.map.getBounds();
      const data = {
        diameter: this.calcBestClusterDistance(),
        cityGuid: this.city,
        leftBottom: bounds.getSouthWest(),
        rightTop: bounds.getNorthEast()
      };
      const { bikes = [], groups = [] } = await getMonitorMapData(data).then(res => res.data);
      this.map.remove(this.map.getAllOverlays('marker'));
      const searchedBike = this.getLastSearchedBike();
      const markers = bikes
        .filter(b => !searchedBike || b.bikeId !== searchedBike.bikeId)
        .map(b => this.bikeToMarker(b))
        .concat(groups.map(g => this.bikeGroupToMarker(g)))
        .concat(searchedBike ? [this.bikeToMarker(searchedBike, true)] : []);
      this.map.add(markers);

      this.totalBikes = bikes.length + groups.reduce((r, g) => r + g.total, 0);
      return true;
    },
    async changeCity(city) {
      if (!this.map) {
        this.map = await this.$refs.amap.getMap();
      }
      this.map.setCity(city.cityName);
      this.getData();
    },
    calcBestClusterDistance() {
      const clusterPixel = 60;
      const zoom = this.map.getZoom();
      const baseLngLat = new window.AMap.LngLat(121.42628699541092, 30.925748854838908);
      const basePixel = this.map.lngLatToContainer(baseLngLat, zoom);
      const endPixel = new window.AMap.Pixel(basePixel.getX() + clusterPixel, basePixel.getY());
      const endLngLat = this.map.containerToLngLat(endPixel);
      return baseLngLat.distance(endLngLat);
    },
    getLastSearchedBike() {
      if (this.bikeId && this.lastSearchedBike && this.bikeId === this.lastSearchedBike.bikeId) {
        return this.lastSearchedBike;
      }
      return null;
    },
    bikeToMarker(bike, showBikeId) {
      const position = new window.AMap.LngLat(bike.lng, bike.lat);
      let markInfo;
      if (this.bikeType === BikeType.RED_PACKET) {
        markInfo = {
          html: this.createMarkerContentHtml({
            type: bike.types,
            label: bike.bikeId === this.bikeId ? `单车${bike.bikeId}` : null,
            bikeType: this.bikeType,
          }),
          size: 24,
        };
      } else {
        markInfo = new Bike(bike).createMarkerHtml(showBikeId && bike.bikeId);
      }

      if (!markInfo) return null;

      const offset = -markInfo.size / 2;
      const marker = new window.AMap.Marker({
        position,
        topWhenClick: true,
        offset: new window.AMap.Pixel(offset, offset),
        content: markInfo.html,
      });

      marker.bike = bike;
      return marker;
    },
    bikeGroupToMarker(group) {
      const southWest = group.leftBottom;
      const northEast = group.rightTop;
      const position = new window.AMap.LngLat(
        (southWest.lng + northEast.lng) / 2,
        (southWest.lat + northEast.lat) / 2
      );
      let markerInfo;
      if (this.bikeType === BikeType.RED_PACKET) {
        let label = group.total;
        if (group.alert) {
          label = `${group.alert}/${label}`;
        }

        markerInfo = {
          html: this.createMarkerContentHtml({
            type: [1000],
            label,
            bikeType: this.bikeType,
          }),
          size: 24,
        };
      } else {
        markerInfo = {
          html: `<div class="monitor-bicycle-group"><span>${group.total}</span></div>`,
          size: 48,
        };
      }
      const offset = -markerInfo.size / 2;
      const marker = new window.AMap.Marker({
        position,
        topWhenClick: true,
        offset: new window.AMap.Pixel(offset, offset),
        content: markerInfo.html,
      });
      marker.groupData = group;
      window.AMap.event.addListener(marker, 'click', () => {
        this.map.setBounds(new window.AMap.Bounds(
          new window.AMap.LngLat(southWest.lng, southWest.lat),
          new window.AMap.LngLat(northEast.lng, northEast.lat)
        ));
        this.getData();
      });
      return marker;
    },
    createMarkerContentHtml({ type, label }) {
      const cls = type.map(t =>
        `monitor-bicycle-${FILTER_ENUM.str[t]} monitor-error-lvl-${FILTER_LVL[t]}`).join(' ');
      return `<div class="monitor-bicycle ${cls}">
          <span class="${label ? 'visible' : 'hidden'}">${label}</span>
          <i class="fa fa-bicycle1">
          <i class="extend"></i></i>
        </div>`;
    },
    changeShow(show) {
      this.show = show;
      if (!show) this.getData();
    }
  },
};
</script>

<style lang="less" scoped>
.map {
  flex: 1;
}
.container{
  position: relative;
}
#tool-bar{
  position: absolute;
  opacity: .8;
  transition: opacity .3s ease;
  left: 80px;
  top: 12px;
  z-index: 1;
  background-color: #1C1E2F;
  padding: 8px 0 8px 8px;
  /deep/ .el-form-item--mini.el-form-item{
    margin-bottom: 0;
  }
}
</style>

<style lang="less">
@import './style.less';
</style>



// WEBPACK FOOTER //
// src/views/monitorMap/index.vue?5c67e893